"use client";
import {
  __spreadValues
} from "../chunk-GOCCUU3Z.js";
import { UAParser } from "ua-parser-js";
import { aaguidMetadata } from "../constants/aaguiMetadata.js";
const formatStringToUUID = (str) => {
  if (str.length !== 32) {
    return void 0;
  }
  return `${str.slice(0, 8)}-${str.slice(8, 12)}-${str.slice(12, 16)}-${str.slice(16, 20)}-${str.slice(20)}`;
};
const formatBiometricHints = (hints) => {
  let hasMobileDevice = false, isOnKnownDevice = false;
  const deviceParsedUA = UAParser();
  const formattedHintsByKey = {};
  hints == null ? void 0 : hints.forEach((hint) => {
    var _a;
    let isMobile = false, isKnownDevice = false, passwordManager, parsedUA, key = "";
    if (hint.useragent) {
      parsedUA = new UAParser(hint.useragent).getResult();
      if (parsedUA.device.type === "mobile" || parsedUA.device.type === "tablet") {
        isMobile = true;
        hasMobileDevice = true;
      }
      if (deviceParsedUA) {
        if (deviceParsedUA.browser.name === parsedUA.browser.name && deviceParsedUA.device.type === parsedUA.device.type && deviceParsedUA.device.vendor === parsedUA.device.vendor && deviceParsedUA.device.model === parsedUA.device.model) {
          isOnKnownDevice = true;
          isKnownDevice = true;
        }
      }
      key = `${parsedUA == null ? void 0 : parsedUA.browser.name}-${parsedUA == null ? void 0 : parsedUA.device.type}-${parsedUA == null ? void 0 : parsedUA.device.vendor}-${parsedUA == null ? void 0 : parsedUA.device.model}`;
    }
    if (hint.aaguid) {
      const formattedAaguid = formatStringToUUID(hint.aaguid);
      if (formattedAaguid) {
        passwordManager = (_a = aaguidMetadata[formattedAaguid]) == null ? void 0 : _a.name;
      }
      key = `${key}${key ? "-" : ""}${passwordManager}`;
    }
    formattedHintsByKey[key] = __spreadValues({ passwordManager, isMobile, isKnownDevice, key }, parsedUA);
  });
  return {
    hasMobileDevice,
    isOnKnownDevice,
    formattedHints: Object.values(formattedHintsByKey)
  };
};
export {
  formatBiometricHints
};
